import React, { FunctionComponent } from "react";

import EmailSettings from "./EmailSettings";
import { useUserData } from "../../hooks/useUserData";
import { useAuthentication } from "../../hooks/useAuthentication";
import { ContentLayout } from "../common/Layout";
import { useUserIdParam } from "../../hooks/useUserIdParam";

interface Props {
  isAuthenticated: boolean;
}

export const Email: FunctionComponent<Props> = ({ isAuthenticated }) => {
  const userId = useUserIdParam();
  const [userData, isLoading, isError] = useUserData(userId);
  useAuthentication(isAuthenticated);

  if (isError) return <p>Fehler beim Laden der Daten</p>;
  return (
    <ContentLayout
      siteTitle={"Spielgruppe Online - E-Mail Einstellungen"}
      title={"E-Mail Einstellungen"}
      isLoading={isLoading}>
      <EmailSettings userId={userId} emailSettings={userData?.settings?.mailSettings} />
    </ContentLayout>
  );
};
